var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M97.500000,69.500000  C82.500000,69.500000 67.498665,69.388702 52.500828,69.568954  C48.098198,69.621872 43.475006,69.256714 39.496613,71.995079  C35.234070,74.929008 34.531082,79.360367 34.518185,84.000053  C34.471844,100.666588 34.519962,117.333374 34.490410,133.999985  C34.478180,140.895554 39.683357,148.525803 48.002380,147.013092  C54.760860,145.784164 58.658321,148.487000 61.739414,154.884705  C64.951622,161.554672 68.226997,168.467453 73.467957,174.030182  C73.717514,174.295074 73.500000,175.000000 73.500000,175.500000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M149.500000,92.500000  C148.698730,94.103203 149.014938,95.825493 149.011948,97.500023  C148.989883,109.833321 149.003922,122.166664 148.998611,134.500000  C148.995148,142.543091 144.532227,147.000000 136.500000,147.000000  C122.333336,147.000000 108.166435,147.042679 94.000175,146.966919  C90.862541,146.950134 88.903023,148.053955 87.429749,150.964432  C84.500465,156.751266 81.319084,162.427338 77.914322,167.947144  C76.778740,169.788132 75.800919,172.054153 73.500000,173.000000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M116.500000,55.000000  C120.582924,55.434315 123.283096,52.661633 125.937172,50.425430  C132.042831,45.281078 136.226547,38.932262 135.976959,30.500683  C135.927475,28.828800 136.139771,27.141212 138.002411,27.092598  C140.098221,27.037897 142.353531,26.075924 144.107895,28.933769  C147.420349,34.329742 145.994400,39.451160 143.876923,44.447842  C142.890884,46.774624 141.776047,48.967632 141.435730,51.452663  C142.606659,53.180038 144.329666,53.003551 146.000000,53.001495  C149.833328,52.996777 153.666672,53.000000 157.500000,53.000000  C164.925186,53.000000 166.505722,55.032127 164.356079,62.500000  C160.505096,62.500000 156.502548,62.500000 152.500000,62.500000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M98.250000,70.000000  C99.821808,75.102707 98.744377,80.334251 98.966232,85.501450  C99.186241,90.625618 99.797279,91.301399 105.000000,91.000000  C115.500000,90.391724 115.384354,90.390030 115.536949,80.000542  C115.656906,71.833977 115.003113,63.660957 115.908783,55.489891  C116.123230,53.555122 115.303787,51.402058 112.499947,51.498440  C112.167007,51.509888 111.833191,51.493454 111.500023,51.500938  C96.401260,51.840096 99.322136,48.974136 99.005768,63.500126  C98.961029,65.554260 99.236549,67.650536 98.000000,69.500000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M150.500000,81.500000  C153.500000,81.500000 156.510254,81.654793 159.497147,81.456917  C162.547867,81.254814 163.852142,82.696678 163.986771,85.500633  C164.123917,88.356987 163.000687,90.879646 159.999161,90.906799  C150.495575,90.992752 141.013626,91.632629 131.464264,90.246193  C127.230675,89.631538 123.591980,88.368233 120.034241,86.436920  C118.782867,85.757629 117.652451,86.266182 116.500000,86.000000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M163.000000,82.000000  C163.500000,81.333336 163.871490,80.477379 164.523560,80.034691  C166.672272,78.575928 166.436188,76.199638 165.844238,74.556099  C165.106140,72.506798 162.934311,71.777191 160.496155,71.943565  C157.178268,72.169968 153.833328,72.000000 150.500000,72.000000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M165.000000,62.500000  C168.452209,66.014275 167.296524,69.298157 164.500000,72.500000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M61.500000,100.500000  C59.729958,101.126579 57.938896,101.297256 56.410255,102.915207  C53.972691,105.495155 53.301994,108.561584 54.151947,111.455368  C55.164574,114.902992 59.796177,116.524765 63.506844,116.053940  C67.817192,115.507027 69.452927,112.545525 69.902443,108.987671  C70.397667,105.068153 67.959557,102.527077 64.489624,101.023949  C63.727173,100.693665 62.833332,100.666672 62.000000,100.500000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M91.500000,100.500000  C87.632614,101.632614 84.105583,102.973351 83.957687,107.998756  C83.835266,112.158348 85.994408,114.610611 89.517204,115.954918  C93.645592,117.530304 98.500984,114.868912 100.000008,110.500000  C101.084068,107.340469 98.278038,102.455383 94.492798,101.018974  C93.709084,100.721558 92.833336,100.666672 92.000000,100.500000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M121.500000,100.500000  C117.437302,101.159012 114.732079,103.431015 114.048286,107.508102  C113.334015,111.766937 116.039574,115.113495 120.500000,115.999985  C124.629189,116.820648 128.625061,114.507256 130.000000,110.500000  C131.084076,107.340477 128.278046,102.455376 124.492805,101.018959  C123.709084,100.721558 122.833336,100.666672 122.000000,100.500000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.67bf2d1da9d68642ef89303bb294bd40.svg";
export { ForwardRef as ReactComponent };